import { render, staticRenderFns } from "./companyWarehouseRegistration.vue?vue&type=template&id=3572b914&scoped=true"
import script from "./companyWarehouseRegistration.vue?vue&type=script&lang=js"
export * from "./companyWarehouseRegistration.vue?vue&type=script&lang=js"
import style0 from "./companyWarehouseRegistration.vue?vue&type=style&index=0&id=3572b914&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3572b914",
  null
  
)

export default component.exports